module.exports = __webpack_public_path__ + "static/media/chicargos-search-product.cc58c50b.jpg";